import axios from "axios";
import { qrOrderingApiURL } from "./QrOrderingApiConfig";

const instance = axios.create({
  baseURL: qrOrderingApiURL,
  withCredentials: false,
  headers: { "Content-Type": "application/json", "ngrok-skip-browser-warning": "true" },
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getQrLocations = () => instance.get('locations/');
export const getHubRiseConnections = () => instance.get('hubrise/connections/');
export const getHubRiseConnection = (locationId) => instance.get(`locations/${locationId}/hubrise/`);
export const startHubRiseOAuth = (locationId) => instance.post(`locations/${locationId}/hubrise/oauth/start/`);
export const completeHubRiseOAuth = (locationId, data) => instance.post(`locations/${locationId}/hubrise/oauth/complete/`, data);
export const disconnectHubRise = (locationId) => instance.post(`locations/${locationId}/hubrise/disconnect/`);
export const getQrMenu = (id) => instance.get(`locations/${id}/menu/`);
export const saveProductPresentation = (id, key, data) => instance.patch(`locations/${id}/menu/products/${encodeURIComponent(key)}/`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const publishProduct = (id, key, data) => instance.post(`locations/${id}/menu/products/${encodeURIComponent(key)}/publish/`, data);
export const getQrTables = (id) => instance.get(`locations/${id}/tables/`);
export const createQrTable = (id, data) => instance.post(`locations/${id}/tables/`, data);
export const updateQrTable = (id, tableId, data) => instance.patch(`locations/${id}/tables/${tableId}/`, data);
export const getDiningSessions = (id) => instance.get(`locations/${id}/sessions/`);

export const getQrOrders = (id, cursor, filters = {}) => instance.get(`locations/${id}/orders/`, { params: { ...(cursor ? { cursor } : {}), ...filters } });

export const getGuestMenuSettings = id => instance.get(`locations/${id}/settings/`);
export const saveGuestMenuSettings = (id, data) => instance.patch(`locations/${id}/settings/`, data, { headers: { 'Content-Type': data instanceof FormData ? 'multipart/form-data' : 'application/json' } });

export const getQrRevisions = id => instance.get(`locations/${id}/revisions/`);
export const enableQrLiveUpdates = id => instance.post(`locations/${id}/hubrise/callback/`);
export const deleteQrTable = (id, tableId) => instance.delete(`locations/${id}/tables/${tableId}/`);

export const syncQrMenu = id => instance.post(`locations/${id}/menu/sync/`);
export const matchQrMenuProduct = (id, identity, data) => instance.post(`locations/${id}/menu/matches/${identity}/`, data);

export const manageQrMenu = (id, data) => instance.patch(`locations/${id}/menu/manage/`, data);

export const endDiningVisit = (id,sessionId) => instance.post(`locations/${id}/sessions/${sessionId}/close/`, {end_locally:true});
